
import { supabase } from "@/integrations/supabase/client";

export interface InvoiceBatch {
  batch_id: number;
  created_at: string;
  month: number;
  year: number;
  run_type: string;
  total_invoices: number;
  total_amount: number;
}

export const getBatches = async (): Promise<InvoiceBatch[]> => {
  const { data, error } = await supabase
    .from('invoice_batches')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching invoice batches:', error);
    throw error;
  }

  return data || [];
};
